import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Badge,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import HostelPage from '../../views/HostelPage/';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../../Loader';
import FileBase64 from 'react-file-base64';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const GLOBAL = require('../../Globals');

class Hostellers extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			modal: false,
			modal1: false,
			sname : '',
			shname : '',
			hlist : [],
			issend : false,
			flist : [],
			rlist : [],
			clist : [],
			files : [],
			files1 : [],
			totalmsg : 0,
			files2 : [],
			isUnicode1 : 0,
			hcrsetype : '',
			host : '',
			hroom : '',
			hfloor : '',
			hcrse  : '',
			hyear : '',
			idd : '',
			stdappno : '',
			stdregno : '',
			stdname : '',
			postFilter : [],
			loading: false,
			_redirectView : false,
			_redirectFeeView : false,
			_message : '',
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			alertClass :'',
			posts: []
			
		}
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onChkChange = this.onChkChange.bind(this);
		this.onRegnoSearchChange = this.onRegnoSearchChange.bind(this);
		this.onHostChange = this.onHostChange.bind(this);
		this.onFloorChange = this.onFloorChange.bind(this);
		this.onappnoSearchChange = this.onappnoSearchChange.bind(this);
		this.onnameSearchChange = this.onnameSearchChange.bind(this);
		this.onHroomChange = this.onHroomChange.bind(this);
		this.onHcourseChange = this.onHcourseChange.bind(this);
		this.onHcourseTypeChange = this.onHcourseTypeChange.bind(this);
		this.onHyearChange = this.onHyearChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onupdateSubmit = this.onupdateSubmit.bind(this);
		this.onSmsSubmit = this.onSmsSubmit.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onView = this.onView.bind(this);
		this.onFeeView = this.onFeeView.bind(this);
	}
	
	toggle(){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	
	onChkChange(e){
		
		if(e.target.checked){
			
			this.state.isUnicode1 = 1;
		}
		else {
			
			this.state.isUnicode1 = 0;
		}
		
	}
	
	
	toggle1(){
		this.setState({
		  modal1: !this.state.modal1
		});
	}

	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
		
			
			this.getdata();
		
	}
	
	addtoggle(e){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	addtoggle1(e){
		this.setState({
		  modal1: !this.state.modal1
		});
	}
	
	onView(dt){
		
		this.state.idd = dt;
		this.setState({_redirectView: true});
	}
	
	onFeeView(dt){
		
		this.state.idd = dt;
		this.setState({_redirectFeeView: true});
	}
	
	
	onChange(e){
		
		this.setState({[e.target.name] : e.target.value});
	}
	
	onRegnoSearchChange(e){
		
		this.state.stdregno = e.target.value;
		this.filterdata();
	}
	
	onHcourseChange(e){
		
		this.state.hcrse = e.target.value;
		this.filterdata();
	}
	
	onHyearChange(e){
		
		this.state.hyear = e.target.value;
		this.filterdata();
	}
	
	onHroomChange(e){
		
		this.state.hroom = e.target.value;
		this.filterdata();
	}
	
	onFloorChange(e){
		
		this.state.hfloor = e.target.value;
		this.filterdata();
	}
	
	onHostChange(e){
		
		this.state.host = e.target.value;
		this.filterdata();
	}
	
	onHcourseTypeChange(e){
		
		this.state.hcrsetype = e.target.value;
		this.filterdata();
		
	}
	
	onnameSearchChange(e){
		
		this.state.stdname = e.target.value;
		this.filterdata();
	}
	
	onappnoSearchChange(e){
		
		this.state.stdappno = e.target.value;
		this.filterdata();
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({
					modal: !this.state.modal
		});
		
		this.gethostdata();
		
	}
	
	onSMSmsg(){
		
		this.setState({
					modal1: !this.state.modal1
		});
	
	}
	
	gethostdata(){
		GetData('hostel/gethostellersbyid/'+this.state.idd).then((result) => {
			let res = result;
			if(res){
				this.setState({
					sname : res[0]['sname'],
					shname : res[0]['hname']
				});
			}
		});
	}
	
	onSubmit(e){
		
		e.preventDefault();
		if(this.state!=''){
			
			PostData('hostel/addhostel',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Hostel Added Successfully!..',
						alertClass:'alert alert-success',
						modal: !this.state.modal
					});
					document.getElementById("cform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
					document.getElementById("cform").reset();
					this.getdata();
				}
			});
		
		}
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('hostel/removehostel',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Hostel Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Hostel',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onupdateSubmit(e){
		e.preventDefault();
		 $("#load_area").show();
		$("#up_btn").hide();
		console.log(this.state);
		if(this.state.idd){
			
			PostData('hostel/updateprofilecard',this.state).then((result) => {
				 $("#load_area").hide();
		          $("#up_btn").show();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Photos Uploaded Successfully!..',
						alertClass:'alert alert-success',
						modal: !this.state.modal
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Room already full',
						alertClass:'alert alert-danger'
					});
					this.getdata();
				}
			});
		
		}
	
	}
	
	
	onSmsSubmit(e){
		e.preventDefault();
		this.setState({issend : true});
		console.log(this.state);
		
			$("#some_div").hide();
			 $("#time").show();
			 
			 			
			PostData('hostel/sendbulksms',this.state).then((result) => {
				let responseJson = result;
					
				if(responseJson.status == '1' ){
				
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
					
			var timeLeft = 10;
			var elem = document.getElementById('time');
			var timerId = setInterval(countdown, 1000);
			function countdown() {
						  if (timeLeft == 0) {
							clearTimeout(timerId);
							 $("#some_div").show();
                             $("#time").hide();
							 alert('SMS Pushed Successfully!..');
							 $("#countid").html('');
						  } else {
							elem.innerHTML = timeLeft + ' seconds remaining';
							timeLeft--;
						  }
						}
			
						
			document.getElementById("smsform").reset();
			 this.setState({modal1: !this.state.modal1,issend : false});
	
	}
	
	getFiles(files){
		this.setState({ files: files })
	}
	
	//base64 Certificate 1
	getFiles1(files1){
		this.setState({ files1: files1 })
	}
	
	//base64 Certificate 2
	getFiles2(files2){
		this.setState({ files2: files2 })
	}
	
	componentWillMount() {
		 
		this.getdata();
		this.gethostel();
		this.getclass();
		this.filterdata();
		
	}
	
	componentDidMount() {
		 
		 $("#load_area").hide();
		
	}
	
	getdata(){
	$("#showLoader").show();
		this.setState({loading:true});
		this.setState({posts : []});
		GetData('hostel/gethostellers').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					postFilter : responseJson,
					loading:false
				});
				this.setState({totalmsg : this.state.postFilter.length});
			}
		});
	}
	
	gethostel(){
		
		GetData('hostel/gethostel').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					hlist : responseJson
				});
			}
		});
	}
	
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					clist : responseJson
				});
			}
		});
	}
	
	
	getfloors(){
		
		GetData('hostel/getfloorbyhostelid/'+this.state.host).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					flist : responseJson
				});
				//this.getrooms();
			}
		});
	}
	
	getrooms(){
		
		GetData('hostel/getroombyfloorid/'+this.state.host+'/'+this.state.hfloor).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					rlist : responseJson
				});

			}
		});
	}
	
	filterdata(){
		
		this.state.postFilter = [];
		var dat = [];
		for(var i=0; i<this.state.posts.length; i++){
			
			console.log(this.state.host);
			console.log(this.state.posts[i].hostel);
			
			if(this.state.stdregno!='' && this.state.stdappno=='' && this.state.stdname=='' && this.state.host=='' && this.state.hfloor=='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].registerno == this.state.stdregno){
					
					dat.push(this.state.posts[i]);
				}
			}
			else if(this.state.stdappno!='' && this.state.stdregno=='' && this.state.stdname=='' && this.state.host=='' && this.state.hfloor=='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].applicationno == this.state.stdappno){
					
					dat.push(this.state.posts[i]);
				}
			}
			else if(this.state.stdappno=='' && this.state.stdregno=='' && this.state.stdname!='' && this.state.host=='' && this.state.hfloor=='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].stdname.toLowerCase().search(this.state.stdname.toLowerCase()) !=-1){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdregno=='' && this.state.stdname =='' && this.state.stdappno=='' && this.state.hfloor=='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname!='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor=='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].stdname.toLowerCase().search(this.state.stdname.toLowerCase()) !=-1){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname!='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor=='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].stdname.toLowerCase().search(this.state.stdname.toLowerCase()) !=-1){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname=='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor!='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].floor == this.state.hfloor){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname!='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor!='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].floor == this.state.hfloor && this.state.posts[i].stdname.toLowerCase().search(this.state.stdname.toLowerCase()) !=-1){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname=='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor!='' && this.state.hroom!='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].floor == this.state.hfloor && this.state.posts[i].room == this.state.hroom){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host=='' && this.state.stdname=='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor=='' && this.state.hroom=='' && this.state.hcrse!=''){
				
				if(this.state.posts[i].class == this.state.hcrse){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname=='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor=='' && this.state.hroom=='' && this.state.hcrse!=''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].class == this.state.hcrse){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname=='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor!='' && this.state.hroom=='' && this.state.hcrse!=''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].class == this.state.hcrse && this.state.posts[i].floor == this.state.hfloor){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname=='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor=='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname=='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor!='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].floor == this.state.hfloor){
					
					dat.push(this.state.posts[i]);
				}
			}
			else if(this.state.host!='' && this.state.stdname=='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor!='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].floor == this.state.hfloor &&  this.state.posts[i].acyear == this.state.hyear){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.host!='' && this.state.stdname=='' && this.state.stdregno=='' && this.state.stdappno=='' && this.state.hfloor!='' && this.state.hroom=='' && this.state.hcrse==''){
				
				if(this.state.posts[i].hostel == this.state.host && this.state.posts[i].floor == this.state.hfloor && this.state.posts[i].dname == this.state.hcrsetype &&  this.state.posts[i].acyear == this.state.hyear){
					
					dat.push(this.state.posts[i]);
				}
			}
		}
		this.setState({postFilter : dat});
		this.setState({totalmsg : this.state.postFilter.length});
	}
	
  render() {
	  
	   $("#load_area").hide();
	   
	   $('#msgarea').keyup(function(){
		
		var chars = this.value.length;
		if( $("#isUnicode1").prop("checked") ){
			var messages1 = Math.ceil(chars / 180),
			remaining1 = messages1 * 180 - (chars % (messages1 * 180) || messages1 * 180);		
		}
		else{
			var messages1 = Math.ceil(chars / 450),
			 remaining1 = messages1 * 450 - (chars % (messages1 * 450) || messages1 * 450);
		}

		$("#remaining1").text(remaining1+ ' characters remaining ');
		$("#messages1").text(messages1 + ' message(s)')
		
	});
	   
	if(this.state._redirectView){
	
		return (<Redirect to={'/hostel/viewbonafide/' + this.state.idd} />);
	}
		
	if(this.state._redirectFeeView){
		
		return (<Redirect to={'/hostel/viewfee/' + this.state.idd} />);
	}
	   
	  $("#host").change(function(){
	
			var host = $(this).val();
			$.get(GLOBAL.BASE_URL+'hostel/getfloorbyhostelid/'+host,function(o){
				console.log(o);
				$("#hfloor").html('');
				$('#hfloor')
					.append($("<option></option>")
					.attr("value",'')
					.text(' -Select Floor- ')); 
				$.each(o,function(key,value){			
					   $('#hfloor')
						.append($("<option></option>")
						.attr("value",value.id)
						.text(value.name)); 	
											
				});	
				
			},'json');
			
		
		});
		
		 $("#hfloor").change(function(){
			
			var host = $("#host").val();
			var floor = $(this).val();
			$.get(GLOBAL.BASE_URL+'hostel/getroombyfloorid/'+host+'/'+floor,function(o){
				console.log(o);
				$("#hroom").html('');
				$('#hroom')
					.append($("<option></option>")
					.attr("value",'')
					.text(' -Select Room- ')); 
				$.each(o,function(key,value){			
					   $('#hroom')
						.append($("<option></option>")
						.attr("value",value.id)
						.text(value.name)); 	
											
				});	
				
			},'json');
			
		
		});
		
		var hnames = this.state.hlist;
		var fnames = this.state.flist;
		var rnames = this.state.rlist;
		var cnames = this.state.clist;
	  
	  /** set showcount select box **/
	this.shows = [
		{value : '20', name : '20'},
		{value : '10', name : '10'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	 
	  /** set showcount select box **/
	this.grad = [
		{value : '', name : 'UG / PG'},
		{value : 'ug', name : 'UG'},
		{value : 'pg', name : 'PG'}
	];
	
	 /** set showcount select box **/
	this.years = [
		{value : '', name : '-Select Year-'},
		{value : '1', name : '1'},
		{value : '2', name : '2'},
		{value : '3', name : '3'}
	];
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.postFilter.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
	  return <tr key = {item}>
				<td>{i+1}</td>
				<td >{item.hname}</td>
				<td >{item.fname}</td>
				<td>{item.rname}</td>
				<td>{item.stdname}</td>
				<td >{item.registerno}</td>
				<td >{item.applicationno}</td>
				<td >{item.clsname}</td>
				<td >{item.sectionname}</td>
				<td >{item.mobile}</td>
				<td>
				{/*<button name="view" className="btn btn-primary btn-sm" onClick={() => this.onFeeView(item.id)} ><i className="fa fa-money"></i></button>
				&nbsp;
				<button name="view" className="btn btn-warning btn-sm" onClick={() => this.onView(item.id)} ><i className="fa fa-eye"></i></button>
					&nbsp;
				<a target="_blank" href={GLOBAL.BASE_URL+'hostel/printtransfer/'+item.id} className="btn btn-primary btn-sm"><i className="fa fa-id-card"></i></a>&nbsp;*/}
				<button name="edithw" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-upload"></i></button>
				</td>
			</tr>;
	});
	  
    return (
		<div>
		  <HostelPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			<Row>
			<Col md="12">
				<Card>
				  <CardHeader>
					<strong>Hostellers : <span>{this.state.postFilter.length}</span></strong> &nbsp;&nbsp; &nbsp;&nbsp;
					
							Hostel : &nbsp;&nbsp;
								<select name="host" id="host" onChange={this.onHostChange} > 
									<option value="">Select Hostel</option>
									{
										hnames.map(function (item) {
											return <option value={item.id }>{item.name}</option>;
										})
									}
								</select>&nbsp;&nbsp;
									Floor : &nbsp;&nbsp;
								<select name="hfloor" id="hfloor" onChange={this.onFloorChange} > 
									<option value="">Select Floor</option>
									{
										fnames.map(function (item) {
											return <option value={item.id }>{item.name}</option>;
										})
									}
								</select>&nbsp;&nbsp;
								Room No : &nbsp;&nbsp;
								<select name="hroom" id="hroom" onChange={this.onHroomChange} > 
									<option value="">Select Room</option>
									{
										rnames.map(function (item) {
											return <option value={item.id }>{item.name}</option>;
										})
									}
								</select>&nbsp;&nbsp;
								Class : &nbsp;&nbsp;
								<select name="hcrse" id="hcrse" onChange={this.onHcourseChange} > 
									<option value="">Select Class</option>
									{
										cnames.map(function (item) {
											return <option value={item.id}>{item.class}</option>;
										})
									}
								</select>&nbsp;&nbsp;
								Name : &nbsp;&nbsp;
								<input type="text" name="stdname" onChange={this.onnameSearchChange} />&nbsp;&nbsp;	
								<br /><br />
							Reg No : &nbsp;&nbsp;
								<input type="text" name="stdregno" onChange={this.onRegnoSearchChange} />
							  &nbsp;&nbsp;App No : &nbsp;&nbsp;
								<input type="text" name="stdappno" onChange={this.onappnoSearchChange} />
								&nbsp;&nbsp;&nbsp;&nbsp;
								<ReactHTMLTableToExcel
								id="test-table-xls-button"
								className="download-table-xls-button"
								table="table-to-xls_report"
								filename="Hostellers_Report"
								sheet="tablexls"
								Button size="xs"
								buttonText="Export"/>
								&nbsp;&nbsp;&nbsp;&nbsp;
								<span id="some_div"><Button size="xs" color="primary" onClick={() =>this.onSMSmsg()}><i className="fa fa-envelope"></i> Send SMS</Button></span><span id="time" className="btn-right"></span>
		
				  </CardHeader>
				  <CardBody>
					<Row>
					  <Col md="12">
						<Table responsive id="table-to-xls_report" width="100%">
						  <thead>
							<tr>
							  <th>S.No</th>
							  <th>Hostel</th>
							  <th>Floor</th>
							  <th>Room</th>
							  <th>Student Name</th>
							  <th>Register No</th>
							  <th>Application</th>
							  <th>Class</th>
							  <th>Section</th>
							  <th>Mobile</th>
							  <th>Manage</th>
							</tr>
						  </thead>
						  <tbody>
							{this.state.loading ?  <tr><td colSpan="10"><center>{'No Data Found'}</center></td></tr> : renderTodos}	
						</tbody>
						</Table>
					  </Col>
					  <Col md="4">
					  <Pagination
								 activePage={this.state.activePage}
								 itemsCountPerPage={this.state.todosPerPage}
								 pageRangeDisplayed={3}
								 totalItemsCount={this.state.postFilter.length}
								 onChange={this.handlePageChange}
								/>
					  </Col>
					   <Col md="2">
					 <select name="show" onChange={this.onShowChange} id="show" >
									{this.shows.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>&nbsp;
							entries
					</Col>
					  <Modal isOpen={this.state.modal} toggle={this.addtoggle} className={'modal-lg ' +this.props.className}>
						<form action="" method="post" role="form" id="chform" encType="multipart/form-data" onSubmit={this.onupdateSubmit}>
						  <ModalHeader toggle={this.toggle}>Hostellers -    Name : {this.state.sname} &nbsp;Hostel Name : {this.state.shname}</ModalHeader>
						  <ModalBody>
							<Row>
							<Col md="3">
					
							  </Col>
							   <Col md="2">
								<FormGroup>
									<Label>Father Photo</Label>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FileBase64 onDone={ this.getFiles.bind(this) }/>
							  </Col>
							  <Col md="3">
					
							  </Col>
							  <Col md="2">
								<FormGroup>
									<Label>Mother Photo</Label>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FileBase64 onDone={ this.getFiles1.bind(this) }/>
							  </Col>
							  <Col md="3">
					
							  </Col>
							<Col md="2">
								<FormGroup>
									<Label>Guardian Photo</Label>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FileBase64 onDone={ this.getFiles2.bind(this) }/>
							  </Col>
							</Row>
						  </ModalBody>
						  <ModalFooter>
							<Button type="submit" color="success" ><span id="up_btn">Upload</span> <span id="load_area"><Loader /></span></Button>{' '}
							<Button color="secondary" onClick={this.toggle}>Cancel</Button>
						  </ModalFooter>
						</form>
					  </Modal>
					   <Modal isOpen={this.state.modal1} toggle={this.addtoggle1} className={'modal-lg ' +this.props.className}>
						<form action="" method="post" role="form" id="smsform" encType="multipart/form-data" onSubmit={this.onSmsSubmit}>
						  <ModalHeader toggle={this.toggle1}>Send SMS to {this.state.postFilter.length} Students</ModalHeader>
						  <ModalBody>
							<Row>
							<Col md="3">
								<FormGroup>
									<Label>Purpose</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
							  <FormGroup>
								 <Input type="text" name="msgpurpose" id="msgpurpose" onChange={this.onChange}  required/>
								</FormGroup>
							  </Col>
							   <Col md="3">
								<FormGroup>
									<Label>Message</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
							  <FormGroup>
								 <Input type="textarea" name="textmessage" id="msgarea" onChange={this.onChange} rows="5" placeholder="Type Message Here" required/>
								  <span id="remaining1">450 characters remaining </span>
								  <br />
								  <span id="messages1">1 message(s)</span>
								</FormGroup>
								  <FormGroup check inline>
									<Label className="form-check-label" check htmlFor="inline-checkbox1" > Is Tamil Message ?</Label>&nbsp;&nbsp;&nbsp;
									<Input className="form-check-input" onChange={this.onChkChange} type="checkbox" id="isUnicode1" name="isUnicode1" />
								</FormGroup>
							  </Col>
							  
							</Row>
						  </ModalBody>
						  <ModalFooter>
							 <Button type="submit" color="success" ><span id="send_btn">Send</span></Button>{' '}
							<Button color="secondary" onClick={this.toggle1}>Cancel</Button>
						  </ModalFooter>
						</form>
					  </Modal>
					</Row>
				  </CardBody>
				</Card>
			</Col>
			</Row>
			</div>
		</div>
    );
  }
}

export default Hostellers;



// WEBPACK FOOTER //
// ./src/hostel/HostelList/hostellers.js